module.exports = __webpack_public_path__ + "img/section5.2fa746c0.png";